import { useStyletron } from "baseui";
import React from "react";
import type { DocsInterfaceProps } from "../../src/chrome/DocsInterface";
import { DocsInterface } from "../../src/chrome/DocsInterface";
import Landing from "../../src/components/Landing";
import { SplashCalloutLink } from "../../src/components/SplashPage";
import { DocLink } from "../../src/markdown-components";

export const GuidesRedirectCallout = () => {
  const [css] = useStyletron();

  return (
    <SplashCalloutLink>
      <span className={css({ fontWeight: 500 })}>Need to extend and customize your API?</span> Check out the guides{" "}
      <DocLink href="/guides">here</DocLink>.
    </SplashCalloutLink>
  );
};

const APIPage = (props: DocsInterfaceProps) => {
  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <Landing
        title={`${props.currentApp.slug} API`}
        contents={[
          "The API documents your auto-generated Gadget API. As you build actions in Gadget, the framework automatically creates the necessary route handlers and produces the API endpoints needed to run your actions.",
          "You can make API calls to your backend in GraphQL, JS, or React. The React client is already installed and kept up to date in your frontend folder. However, you can also make external API calls.",
        ]}
      />
    </DocsInterface>
  );
};

export default APIPage;
